import {AfterViewInit, Component, OnDestroy, OnInit, TemplateRef, ViewChild,} from '@angular/core';
import {ModalService} from '../../services/modal/modal.service';
import {AlertService} from '../../services/notify/alert.service';
import {HelpersService} from '../../services/helpers.service';

@Component({
    selector: 'app-component-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('confirmModal') public confirmModal: TemplateRef<any>;


    constructor(
        protected modalService: ModalService,
        protected alertService: AlertService,
        public helper: HelpersService,
    ) {
    }

    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
        this.modalService.confirmModalTemplate = this.confirmModal;
    }

    ngOnDestroy(): void {
    }
}
